package com.anjuros.website.templates.template1.modules

import com.anjuros.website.templates.template1.util.ResKey


enum class Template1Review(
    var title: ResKey,
    var review: ResKey
) {

    Review1(
        ResKey.TEMPLATE1_REVIEW1_TITLE,
        ResKey.TEMPLATE1_REVIEW1
    ),
    Review2(
        ResKey.TEMPLATE1_REVIEW2_TITLE,
        ResKey.TEMPLATE1_REVIEW2
    ),
    Review3(
        ResKey.TEMPLATE1_REVIEW3_TITLE,
        ResKey.TEMPLATE1_REVIEW3
    ),
    Review4(
        ResKey.TEMPLATE1_REVIEW4_TITLE,
        ResKey.TEMPLATE1_REVIEW4
    ),
    Review5(
        ResKey.TEMPLATE1_REVIEW5_TITLE,
        ResKey.TEMPLATE1_REVIEW5
    ),
    Review6(
        ResKey.TEMPLATE1_REVIEW6_TITLE,
        ResKey.TEMPLATE1_REVIEW6
    )


}